import React from 'react';
import TrackVisibility from "react-on-screen";
import Skill from "./Skill";

const progressData = [
    {
      id: 1,
      title: "Money Management",
      percantage: 90,
      progressColor: "#059DFF",
    },
    {
      id: 2,
      title: "Consultation",
      percantage: 75,
      progressColor: "#FB5343",
    },
    {
      id: 3,
      title: "Sales Management",
      percantage: 70,
      progressColor: "#E33FA1",
    },
    {
      id: 4,
      title: "Time Management",
      percantage: 95,
      progressColor: "#6549D5",
    },
];

const ProgressbarOne = () => {
    return (
        <>
            {progressData.map((progress) => (
            <TrackVisibility
                once
                key={progress.id}
                className="single-progress"
            >
                <Skill progress={progress} /> 
            </TrackVisibility>
            ))} 
        </>
    )
}


export default ProgressbarOne;
